import React from 'react';
import './index.css';

import IconCheckMark from '../icons/IconCheckMark';

const BaseCheckbox = (props) => {
  const {
    checkboxId,
    isChecked,
    checkboxBody,
    onCheck,
    dontBoldOnCheck,
    checkboxClassName,
    bodyClassName,
    isDisabled
  } = props;

  return (
    <div  className={'base-checkbox ' + (checkboxClassName ? checkboxClassName : '')}>
      <input
        id={checkboxId}
        type="checkbox"
        className={'base-checkbox__input' + (isChecked ? ' base-checkbox__input_checked' : '')}
        checked={isChecked}
        onChange={onCheck}
        disabled={isDisabled==='accepted'}
      />
      <label htmlFor={checkboxId} className={'base-checkbox__label ' + (!dontBoldOnCheck ? 'base-checkbox__label--boldable' : '')}>
        <span  className={"base-checkbox__checkbox"  }>
          <span className="base-checkbox__checkmark">
            <IconCheckMark />
          </span>
        </span>
        <div className={"base-checkbox__body " + (bodyClassName ? bodyClassName : '')}>
          {checkboxBody}
        </div>
      </label>
    </div>
  );
}

export default BaseCheckbox;
